export const siteConfig = {
  name: '姐姐的朋友',
  tagline: '让姐姐的朋友圈为你所用',
  description: '「姐姐的朋友」是你打开优质社交圈子的最佳切入点。深度解析如何通过姐姐的朋友拓展人脉、建立信任关系，让你在新圈子中快速站稳脚跟，获得更多机会与资源。',
  keywords: '姐姐的朋友,姐姐的朋友圈拓展,如何融入姐姐的朋友圈,通过姐姐认识新朋友,借助姐姐人脉资源,姐姐介绍朋友技巧,跨圈社交方法',
  url: 'https://jiejiefriends.com',
  author: '姐姐的朋友编辑部',
  email: 'hello@jiejiefriends.com',
  founded: '2024',
  socialLinks: {
    wechat: '#',
    weibo: '#',
    xiaohongshu: '#',
  },
};

export const faqItems = [
  {
    question: '什么是"姐姐的朋友"？',
    answer: '「姐姐的朋友」是一个专注于社交拓展与人脉建设的知识平台。我们帮助用户通过姐姐的朋友圈这一天然渠道，学习社交技巧、拓展优质人脉、建立深度信任关系，实现个人社交圈的有效扩张。',
  },
  {
    question: '我性格内向，能通过姐姐拓展朋友圈吗？',
    answer: '完全可以。内向者往往更擅长一对一的深度交流，这在通过姐姐介绍朋友时反而是优势。姐姐的推荐已经为你建立了初步信任，你只需要按照自己的节奏，在舒适的场合展示真实的自己。我们在"社交心理学"分类中提供了专门针对内向者的社交策略。',
  },
  {
    question: '姐姐不愿意给我介绍朋友怎么办？',
    answer: '这很常见。首先不要给姐姐压力。你可以从展现自己的社交成熟度开始——让姐姐看到你是一个值得信赖的人。同时，创造自然的见面机会（比如邀请姐姐和朋友一起参加活动），而不是直接要求"介绍朋友"。具体方法可以参考我们的文章"如何优雅地让姐姐介绍朋友给你认识"。',
  },
  {
    question: '如何判断姐姐的朋友是否适合深交？',
    answer: '判断标准有三个：一是价值观是否契合，二是对方是否展现出真诚和一致性，三是你们之间是否有自然的"化学反应"。不要因为对方是姐姐的朋友就盲目信任或排斥，保持开放而审慎的态度，让关系在自然互动中发展。',
  },
  {
    question: '通过姐姐认识的朋友，如何建立独立于姐姐的关系？',
    answer: '关键在于创造"独立连接点"。找到你和对方共同的兴趣或话题，适时组织不包含姐姐的互动，让关系从"某某的妹妹/弟弟"转变为独立的个体。但要始终保持对姐姐的尊重和透明，不要因为建立了新关系而伤害原有的亲情纽带。',
  },
  {
    question: '网站上的内容收费吗？',
    answer: '「姐姐的朋友」网站上的所有文章和内容均为免费提供。我们致力于让更多人受益于科学的社交方法和心理学知识。未来如果推出深度课程或一对一咨询服务，会提前在网站公告。',
  },
];

export const aboutContent = {
  brandStory: [
    '「姐姐的朋友」诞生于一个简单的观察：大多数人都在为拓展社交圈而焦虑，却忽略了自己身边最宝贵的社交资源——家人的朋友圈。',
    '我们的创始团队由一群深耕社交心理学和人脉管理领域的专业人士组成。在多年的研究和实践中，我们发现了一个被严重低估的社交渠道：姐姐的朋友圈。姐姐作为最亲近的家人，她的朋友圈天然携带着信任背书、经过时间筛选，且覆盖多个领域——这几乎是一个完美的社交入口。',
    '于是，「姐姐的朋友」应运而生。我们致力于系统性地解析如何借助姐姐的朋友圈这一独特渠道，帮助每一位用户掌握科学的社交方法，建立真诚的人际关系，在社交中实现个人成长与机会获取的双赢。',
    '我们的内容涵盖姐姐朋友圈拓展策略、跨圈社交方法、人脉长期维护技巧以及社交心理学底层逻辑四大板块，每一篇文章都经过深入研究和精心撰写，确保内容既有理论深度，又具备实操价值。',
  ],
  values: [
    { title: '真诚为本', description: '所有社交技巧都建立在真诚的基础上。我们反对功利的"人脉经营"，倡导以真心换真心的社交理念。' },
    { title: '科学导向', description: '我们的内容基于心理学、社会学和行为科学的研究成果，拒绝空洞的心灵鸡汤，只提供有科学依据的方法。' },
    { title: '实操落地', description: '每一条建议都经过实践验证，让用户读了就能用、用了就有效。我们不追求理论的华丽，只关注方法论的有效性。' },
    { title: '温暖陪伴', description: '我们理解社交拓展中的不安与焦虑。我们不只是提供方法，更致力于成为你社交成长路上的温暖伙伴。' },
  ],
  reputation: [
    {
      name: '小雅',
      role: '市场营销经理',
      content: '通过姐姐的介绍，我认识了一位行业前辈，现在已经是我们公司的长期顾问了。「姐姐的朋友」教会了我如何优雅地维护这种关系，真的受益匪浅。',
      avatar: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20photography%20style%2C%20approachable%20and%20confident%20expression%2C%20simple%20composition&width=200&height=200&seq=avatar-xiaoya&orientation=squarish',
    },
    {
      name: '明辉',
      role: '自由职业者',
      content: '作为一个内向的人，我以前很害怕社交。但网站里关于内向者社交的文章给了我很大的信心，我现在已经通过姐姐的圈子认识了三个志同道合的朋友。',
      avatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20man%20portrait%20with%20gentle%20smile%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20photography%20style%2C%20thoughtful%20and%20kind%20expression%2C%20simple%20composition&width=200&height=200&seq=avatar-minghui&orientation=squarish',
    },
    {
      name: '思雨',
      role: '大学讲师',
      content: '跨圈社交的5个黄金法则那篇文章简直是我的"社交圣经"。现在我在学术圈和创业圈之间切换自如，多亏了这些实用的方法论。',
      avatar: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20portrait%20with%20intellectual%20warmth%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20photography%20style%2C%20confident%20and%20approachable%20expression%2C%20simple%20composition&width=200&height=200&seq=avatar-siyu&orientation=squarish',
    },
  ],
};

export const contactInfo = {
  email: 'hello@jiejiefriends.com',
  wechat: 'jiejiefriends',
  address: '中国上海市静安区南京西路1788号',
  workingHours: '周一至周五 9:00 - 18:00',
};